import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase, ServiceGuyInfo } from 't4core';
import { T4_ServiceDialog } from "../serviceDialog/serviceDialog";
import { TransferSummaryDialog } from "../transferSummaryDialog/transferSummaryDialog";



@Component({
  selector: 'selectServiceGuyDialog',
  templateUrl: 'selectServiceGuyDialog.html',
  styleUrls: ['./selectServiceGuyDialog.css']
})
export class SelectServiceGuyDialog extends DialogBase {

  public serviceGuy: ServiceGuyInfo;

  constructor(
    public dialogRef: MatDialogRef<T4_ServiceDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super("selectServiceGuy");
  }

  public async serviceguySelected(serviceguy: ServiceGuyInfo) {
    //If we have locks, then we open a summary that needs confirmation what we are moving and to.
    if (this.data.locks) {
      var result = await this.UI.openDialog('T4.Service.TransferSummary', {
        width: "600px",
        data: { locks: this.data.locks, serviceguy: serviceguy, mode: "Transfer" }
      });

      if (result)
        this.dialogRef.close(serviceguy)
    }
    //If we have not provde any locks, we just return the selected guy directly.
    else {
      this.dialogRef.close(serviceguy);
    }

  }

  public close() {
    this.dialogRef.close();
  }
}
